import {
  SET_CLASSIFICATION,
  SET_INITIALIZING,
  SET_SECOND_INIT_PENDING,
  SET_OUTLIERS_INCLUDED,
  SET_HAS_PERSISTED_STATE,
  SET_ORIGINAL_COLUMN_SET,
  SET_CUSTOM_COLUMN_SET,
  SET_FX_SETTING,
  SET_COMPS_TYPE,
  SET_FILTER_ITEM_MAP,
  SET_SORT_INFO,
  RESET_COMPS,
  CLEAR_COMPS,
} from './mutations'

import setClassificationFilter from '@/spreadsheets/utils/setClassificationFilter.js'
import getActiveSheet from '@/spreadsheets/getActiveSheet'
import { getDefaultState } from '@/stores/Comparables/state'
import persistComps from '@/utils/comparables/persistComps'
import { getComps, getCompsCompanyData } from '@cognitivecredit/ui-utils'
import { ComparablesTypes } from '@/components/comparables/ComparablesTypes'

const persistCompsFromState = (state) => {
  persistComps(state.compsType, {
    outliersIncluded: state.outliersIncluded,
    classificationSelected: state.classificationSelected,
    fxSetting: state.fxSetting[state.compsType],
    customColumnSet: state.customColumnSet,
    filterItemMap: state.filterItemMap,
    sortInfo: state.sortInfo,
  })
}

export default {
  setClassificationView({ commit, state }, { payload, persist }) {
    commit(SET_CLASSIFICATION, payload)
    setClassificationFilter(getActiveSheet(), 'GICS Level', payload)
    if (persist) {
      persistCompsFromState(state)
    }
  },
  setOutliersIncluded({ commit, state }, { payload, persist }) {
    commit(SET_OUTLIERS_INCLUDED, payload)
    if (persist) {
      persistCompsFromState(state)
    }
  },
  setHasPersistedState({ commit }, payload) {
    commit(SET_HAS_PERSISTED_STATE, payload)
  },
  setOriginalColumnSet({ commit }, payload) {
    commit(SET_ORIGINAL_COLUMN_SET, payload)
  },
  setCustomColumnSet({ commit, state }, { payload, persist }) {
    commit(SET_CUSTOM_COLUMN_SET, payload)
    if (persist) {
      persistCompsFromState(state)
    }
  },
  async getComparables(unused, payload) {
    const res = await getComps(payload)
    return res?.data
  },

  async getCompanyComparablesWithKeys(unused, payload) {
    const [compsRes, keysRes] = await Promise.all([getComps(payload), getCompsCompanyData()])
    const compsData = compsRes?.data ?? {}
    compsData.company[0]['companies'] = keysRes?.data
    return compsData
  },
  setComparablesInitializationStatus({ commit }, payload) {
    commit(SET_INITIALIZING, payload)
  },
  setSecondInitPending({ commit }, payload) {
    commit(SET_SECOND_INIT_PENDING, payload)
  },
  setFXSetting({ commit, state }, { payload, persist }) {
    commit(SET_FX_SETTING, payload)
    if (persist) {
      persistCompsFromState(state)
    }
  },
  setCompsType({ commit }, payload) {
    commit(SET_COMPS_TYPE, payload)
  },
  setFilterItemMap({ commit, state }, { payload, persist, licenseColumnIndex }) {
    const relevantFilters = payload.filter((condition) => {
      if (state.compsType === ComparablesTypes.SECTOR) {
        return condition.index !== 1
      }
      if ([ComparablesTypes.COMPANY, ComparablesTypes.MARKET, ComparablesTypes.MOVERS].includes(state.compsType)) {
        return condition.index !== licenseColumnIndex
      }
      return true
    })
    commit(SET_FILTER_ITEM_MAP, relevantFilters)
    if (persist) {
      persistCompsFromState(state)
    }
  },
  setSortInfo({ commit, state }, { payload, persist }) {
    commit(SET_SORT_INFO, payload)
    if (persist) {
      persistCompsFromState(state)
    }
  },
  // powers the Reset button, but it leaves the original column defs
  // in place.
  reset({ commit, state }, { payload, persist }) {
    commit(RESET_COMPS, payload)
    if (state.compsType === 'sector' && (payload === 'all' || payload.includes('gics'))) {
      setClassificationFilter(getActiveSheet(), 'GICS Level', getDefaultState().classificationSelected)
    }
    if (persist) {
      persistCompsFromState(state)
    }
  },
  // this is to be used in between different comps pages.
  clear({ commit }) {
    commit(CLEAR_COMPS)
  },
}
